
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';
import onClickOutside from 'react-onclickoutside';

import Translatable from '../../../../Translatable';

import styles from './styles.js';

class FlyoutNavLinkGroup extends Component {
    static propTypes = {
        title: PropTypes.object.isRequired,
        dropdown: PropTypes.object.isRequired,
        dropdownLinkGroups: PropTypes.array.isRequired,
        toggleNavDropdown: PropTypes.func.isRequired
    }

    handleClickOutside() {
        const { dropdown, toggleNavDropdown } = this.props;
        if (dropdown.isVisible) {
            toggleNavDropdown();
        }
    }

    render() {
        const { title, dropdown, toggleNavDropdown, dropdownLinkGroups } = this.props;
        return (
            <li aria-hidden="false">
                <div>
                    <button
                        className={css(styles.link)}
                        onClick={toggleNavDropdown}
                    >
                        <div className={css(styles.containerTableCell, styles.containerTableCell_fullWidth, styles.containerTableCell_alignMiddle)}>
                            <div className={css(styles.containerTableCell, styles.containerTableCell_alignMiddle)}>
                                <span>
                                    <Translatable content={title} />
                                </span>
                            </div>
                            <div className={css(styles.menuIndicator)}>
                                <div
                                    className={css(styles.iconWrapper)}
                                    style={
                                        dropdown && dropdown.isVisible ?
                                            { transform: 'rotate(180deg)' } :
                                            { transform: 'rotate(0deg)' }
                                    }
                                >
                                    <svg
                                        viewBox="0 0 18 18"
                                        role="presentation"
                                        aria-hidden="true"
                                        focusable="false"
                                        style={{
                                            display: 'block',
                                            fill: 'currentcolor',
                                            height: '1em',
                                            width: '1em'
                                        }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M16.291 4.295a1 1 0 1 1 1.414 1.415l-8 7.995a1 1 0 0 1-1.414 0l-8-7.995a1 1 0 1 1 1.414-1.415l7.293 7.29 7.293-7.29z"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </button>
                    {
                        dropdown && dropdown.isVisible ?
                            <div>
                                <ul
                                    role="tree"
                                    className={css(styles.list)}
                                >
                                    {dropdownLinkGroups.map(dropdownLinkGroup =>
                                        dropdownLinkGroup.links.filter(link => link.shown).map(link => {
                                            return (
                                                <li
                                                    key={shortid.generate()}
                                                    role="treeitem"
                                                >
                                                    <Translatable attributes={{ title: link.title }}>
                                                        <a
                                                            href={link.url}
                                                            className={css(styles.container_link)}
                                                        >
                                                            <div className={css(styles.content_baseline)}>
                                                                <div className={css(styles.container_table)}>
                                                                    <div className={css(styles.container_table_child)}>
                                                                        <div className={css(styles.text)}>
                                                                            <Translatable content={link.title} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </Translatable>
                                                </li>
                                            );
                                        })
                                    )}
                                </ul>
                            </div> : null
                    }
                </div>
            </li>
        );
    }
};

export default onClickOutside(FlyoutNavLinkGroup);



// WEBPACK FOOTER //
// ./src/components/Header/FlyoutMenu/FlyoutNav/FlyoutNavLinkGroup/FlyoutNavLinkGroup.jsx